export default "__VITE_ASSET__abb47c3b__"